import m, { memo as c } from "react";
import { Accordion as i } from "@chakra-ui/react";
const u = c(
  ({
    children: o,
    allowMultiple: t = !0,
    defaultIndex: r,
    onChange: e
  }) => /* @__PURE__ */ m.createElement(
    i,
    {
      defaultIndex: r,
      allowMultiple: t,
      onChange: e,
      width: "100%"
    },
    o
  )
);
export {
  u as CustomAccordion
};
